<script lang="ts" setup>
import AirlinePricingTable from "@/data-views/tables/airline_pricing/AirlinePricingTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "AirlinePricing",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <AirlinePricingTable />
    </VCol>
  </VRow>
</template>
